import { CartDetails } from "../lib/cart/CartDetails";
import { NextRouter } from "next/router";
import Routes from "../routes";

export function startAddToCartFlow(
  router: NextRouter,
  fontName: string,
  cartDetails?: CartDetails | null
) {
  if (!cartDetails?.licenseUsage) {
    push(router, Routes.fonts.add.licenseUsage(fontName));
  } else if (!cartDetails.licenseHolder) {
    push(router, Routes.fonts.add.licenseHolder(fontName));
  } else {
    push(router, Routes.fonts.add.licenseTypes(fontName));
  }
}

export function push(router: NextRouter, url: string) {
  return router.push(url, undefined, { scroll: false });
}
